import * as React from 'react';
import * as styled from './styled';
import {AnswerProps} from './types';
import {useContext} from '../../../../../../hooks/useContext';
import Checkbox from '../../../../../../../../../../../Checkbox';
import Radio from '../../../../../../../../../../../Radio';

/**
 * The answer card.
 * @param {AnswerProps} props
 * @return {React.ReactElement<AnswerProps>}
 * @constructor
 */
export default function Answer(
    props: AnswerProps,
): React.ReactElement<AnswerProps> {
  const {block, index} = useContext();

  // @ts-ignore
  const isSeveral: boolean = block.isSeveral;

  /**
   * Render input.
   * @return {JSX.Element}
   */
  function renderInput(): JSX.Element {
    /**
     * Get input component.
     * @return {(props: CheckboxProps) => React.ReactElement}
     */
    function getInputComponent() {
      return isSeveral ? Checkbox : Radio;
    }

    const InputComponent = getInputComponent();

    return (
      <styled.InputContainer>
        <InputComponent
          name={`block-${index}`}
        />
      </styled.InputContainer>
    );
  }

  /**
   * Render text.
   * @return {JSX.Element}
   */
  function renderText(): JSX.Element {
    return (
      <styled.Text>
        {props.text}
      </styled.Text>
    );
  }

  /**
   * Render note.
   * @return {JSX.Element | undefined}
   */
  function renderNote(): JSX.Element | undefined {
    return props.note ? (
      <styled.Note>
        {props.note}
      </styled.Note>
    ) : undefined;
  }

  return (
    <styled.Wrapper>
      {renderInput()}
      {renderText()}
      {renderNote()}
    </styled.Wrapper>
  );
}
